import React, { Component } from "react";
import CustomRadio from "./CustomRadio";

export default class CustomRadioGroup extends Component {
  render() {
    const { choices, value, onClickRadio, name, legend } = this.props;
    if (!choices) {
      return <div>Error: no choices for radio received</div>;
    }
    return (
      <fieldset>
        <legend className="sr-only">{legend}</legend>
        {choices.map((choice) => (
          <div key={choice.id}>
            <CustomRadio
              label={choice.label}
              key={choice.id}
              id={choice.id}
              selected={value === choice.id}
              clickRadio={onClickRadio}
              disabled={choice.disabled}
              name={name}
              ariaLabel={choice.ariaLabel}
            />
            {choice.append}
          </div>
        ))}
      </fieldset>
    );
  }
}
